export default {
    "incomeGoal": 100.0,
    "retirementStartAge": 65,
    "retirementEndAge": 95,
    "socialSecurityStartAge": 70,
    "incomeGoalUnit": "PCT",
    "participantProfile": {
        "firstName": "SUSAN",
        "lastName": "LONG",
        "gender": null,
        "bpId": 12781306,
        "rpsiid": "9687d3d3-16a0-42c5-8af1-03c1839c4622",
        "birthDate": "1959-08-05T00:00:00.000+00:00"
    },
    "scenarioId": 9178,
    "scenarioName": null,
    "scenarioType": "PRM",
    "spouseInclude": "Y",
    "overrideRetirementStartAge": false,
    "spouseRetirementStartAge": 65,
    "spouseRetirementEndAge": 95,
    "socialSecurityAmount": null,
    "spouseSocialSecurityStartAge": 70,
    "spouseSocialSecurityAmount": null,
    "spouseProfile": null,
    "accounts": [
        {
            "id": 10544,
            "bpId": 12781306,
            "name": "test 54321",
            "asOfDate": "2023-10-31T04:00:00.000+00:00",
            "balance": 1245353.08,
            "accountCategory": "TRACAccountSummary",
            "displayAccountCategory": "RPSTRACAccountSummary",
            "displayGroup": "T. Rowe Price Retirement Accounts",
            "includeInScenario": true,
            "overrideAccountTypeCode": null,
            "clientNumber": null,
            "planNumber": "TB1298",
            "retailTypeCategory": null,
            "type": null,
            "displayType": "401K",
            "yodleeAgreementId": null,
            "idmAgreementId": null,
            "yodleeInstitutionId": null,
            "action": null,
            "status": "ACTIVE",
            "contribution": [
                {
                    "id": "A",
                    "sourceName": "SALARY REDUCTION",
                    "amount": 75.0,
                    "unit": "DOL",
                    "frequency": null,
                    "maxAmountPercent": null,
                    "maxAmountDollar": null,
                    "inputType": " "
                }
            ],
            "planMaxAmountDollar": 18000.0,
            "planMaxAmountPercent": 1.0,
            "planMaxCatchUpAmountDollar": null,
            "assetAllocation": null,
            "onlineContribEligible": true,
            "hsaRecordKeeperId": null,
            "hsaPlanSponsorId": null,
            "includeOnly": true,
            "century": true
        },
        {
            "id": null,
            "bpId": 12781306,
            "name": "LIPOSCIENCE INC. 401(K) RETIREMENT PLAN",
            "asOfDate": "2023-10-31T04:00:00.000+00:00",
            "balance": 88955.08,
            "accountCategory": "TRACAccountSummary",
            "displayAccountCategory": "RPSTRACAccountSummary",
            "displayGroup": "T. Rowe Price Retirement Accounts",
            "includeInScenario": true,
            "overrideAccountTypeCode": null,
            "clientNumber": null,
            "planNumber": "TB0344",
            "retailTypeCategory": null,
            "type": "A",
            "displayType": "401K",
            "yodleeAgreementId": null,
            "idmAgreementId": null,
            "yodleeInstitutionId": null,
            "action": null,
            "status": "ACTIVE",
            "contribution": [
                {
                    "id": "A",
                    "sourceName": "SALARY REDUCTION",
                    "amount": 150.0,
                    "unit": "DOL",
                    "frequency": null,
                    "maxAmountPercent": null,
                    "maxAmountDollar": null,
                    "inputType": " "
                }
            ],
            "planMaxAmountDollar": 18000.0,
            "planMaxAmountPercent": 1.0,
            "planMaxCatchUpAmountDollar": null,
            "assetAllocation": null,
            "onlineContribEligible": true,
            "hsaRecordKeeperId": null,
            "hsaPlanSponsorId": null,
            "includeOnly": true,
            "century": true
        },
        {
            "id": 11452,
            "bpId": 12781306,
            "name": "Dag IRA",
            "asOfDate": "2023-11-01T01:58:27.396+00:00",
            "balance": 609447.65,
            "accountCategory": "YodleeAccountSummary",
            "displayAccountCategory": "YodleeAccountSummary",
            "displayGroup": "Outside Retirement Accounts",
            "includeInScenario": true,
            "overrideAccountTypeCode": "4aPRX",
            "clientNumber": null,
            "planNumber": null,
            "retailTypeCategory": null,
            "type": "0",
            "displayType": "INDIVIDUAL_RETIREMENT_ACCOUNT_IRA",
            "yodleeAgreementId": "11604412",
            "idmAgreementId": null,
            "yodleeInstitutionId": 16441,
            "action": null,
            "status": "ACTIVE",
            "contribution": null,
            "planMaxAmountDollar": null,
            "planMaxAmountPercent": null,
            "planMaxCatchUpAmountDollar": null,
            "assetAllocation": {
                "stockPercent": 1.0,
                "moneyMarketPercent": 0.0,
                "bondsPercent": 0.0,
                "otherPercent": 0.0
            },
            "onlineContribEligible": null,
            "hsaRecordKeeperId": null,
            "hsaPlanSponsorId": null,
            "includeOnly": false,
            "century": null
        },
        {
            "id": 11453,
            "bpId": 12781306,
            "name": "Dag 401(k)",
            "asOfDate": "2023-11-01T01:58:27.396+00:00",
            "balance": 643349.31,
            "accountCategory": "YodleeAccountSummary",
            "displayAccountCategory": "YodleeAccountSummary",
            "displayGroup": "Outside Retirement Accounts",
            "includeInScenario": true,
            "overrideAccountTypeCode": "4kPRX",
            "clientNumber": null,
            "planNumber": null,
            "retailTypeCategory": null,
            "type": "0",
            "displayType": "EMPLOYEE_RETIREMENT_ACCOUNT_401K",
            "yodleeAgreementId": "11604408",
            "idmAgreementId": null,
            "yodleeInstitutionId": 16441,
            "action": null,
            "status": "ACTIVE",
            "contribution": null,
            "planMaxAmountDollar": null,
            "planMaxAmountPercent": null,
            "planMaxCatchUpAmountDollar": null,
            "assetAllocation": {
                "stockPercent": 0.75,
                "moneyMarketPercent": 0.02,
                "bondsPercent": 0.23,
                "otherPercent": 0.0
            },
            "onlineContribEligible": null,
            "hsaRecordKeeperId": null,
            "hsaPlanSponsorId": null,
            "includeOnly": false,
            "century": null
        },
        {
            "id": 11454,
            "bpId": 12781306,
            "name": "Dag Brokerage Account",
            "asOfDate": "2023-11-01T01:58:27.396+00:00",
            "balance": 394738.72,
            "accountCategory": "YodleeAccountSummary",
            "displayAccountCategory": "YodleeAccountSummary",
            "displayGroup": "Outside Retirement Accounts",
            "includeInScenario": true,
            "overrideAccountTypeCode": "457PX",
            "clientNumber": null,
            "planNumber": null,
            "retailTypeCategory": null,
            "type": "345",
            "displayType": "BROKERAGE_CASH",
            "yodleeAgreementId": "11604404",
            "idmAgreementId": null,
            "yodleeInstitutionId": 16441,
            "action": null,
            "status": "ACTIVE",
            "contribution": null,
            "planMaxAmountDollar": null,
            "planMaxAmountPercent": null,
            "planMaxCatchUpAmountDollar": null,
            "assetAllocation": {
                "stockPercent": 1.0,
                "moneyMarketPercent": 0.0,
                "bondsPercent": 0.0,
                "otherPercent": 0.0
            },
            "onlineContribEligible": null,
            "hsaRecordKeeperId": null,
            "hsaPlanSponsorId": null,
            "includeOnly": false,
            "century": null
        }
    ],
    "events": null,
    "compensations": [
        {
            "id": 10046,
            "bpId": 12781306,
            "clientNumber": null,
            "compensationType": "ASLRY",
            "payFrequency": "MLY",
            "amount": 72551.0,
            "action": null,
            "source": "userEntered",
            "tracPlanNumber": "TB0344",
            "sponsorProvidedPayFreq": false
        },
        {
            "id": 10047,
            "bpId": 12781306,
            "clientNumber": null,
            "compensationType": "ASLRY",
            "payFrequency": "MLY",
            "amount": 40000.0,
            "action": null,
            "source": "userEntered",
            "tracPlanNumber": "TB1298",
            "sponsorProvidedPayFreq": false
        },
        {
            "id": 10048,
            "bpId": 12781306,
            "clientNumber": null,
            "compensationType": "ASLRY",
            "payFrequency": "MLY",
            "amount": 40000.0,
            "action": null,
            "source": "userEntered",
            "tracPlanNumber": "TB1299",
            "sponsorProvidedPayFreq": false
        }
    ]
}
